import { render } from "./VODMetaTab.vue?vue&type=template&id=d2f4c4ce"
import script from "./VODMetaTab.vue?vue&type=script&setup=true&lang=js"
export * from "./VODMetaTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VOD/VODMetaTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d2f4c4ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d2f4c4ce', __exports__)) {
    api.reload('d2f4c4ce', __exports__)
  }
  
  module.hot.accept("./VODMetaTab.vue?vue&type=template&id=d2f4c4ce", () => {
    api.rerender('d2f4c4ce', render)
  })

}


export default __exports__